/**
 * en-selected-variant.js
 * Keeps data-selected-variant on .product-info__buy-buttons in sync
 * with the active variant whenever the user changes their selection.
 *
 * The theme fires a custom "variant:change" event on the product form
 * with event.detail.variant containing the new variant object.
 */

(function () {
  function init() {
    document.querySelectorAll('.product-info__buy-buttons[data-selected-variant]').forEach((buyButtons) => {
      // The product <form> is a child of this div, and variant:change bubbles up,
      // so we can listen directly on the buy-buttons wrapper.
      buyButtons.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        const slugify = (str) => str ? str.toLowerCase().replace(/\s+/g, '-') : '';

        buyButtons.dataset.selectedVariant = variant ? variant.id : '';
        buyButtons.dataset.variantOption1 = slugify(variant?.option1);
        buyButtons.dataset.variantOption2 = slugify(variant?.option2);
        buyButtons.dataset.variantOption3 = slugify(variant?.option3);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
